import * as React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { getIsCpcAuction } from 'shared/utils/auction';

import { PromotionDescription } from '../../../../components/PromotionDescription';
import { useOfferContext } from '../../../../context';
import { useAuctionContext } from '../../../../context/AuctionContext';
import { shouldShowPromotionDescription } from '../../../../utils/shouldShowPromotionDescription';

export const PromotionDescriptionContainer = () => {
  const { config } = useApplicationContext();
  const { offer, vasList, user } = useOfferContext();
  const { currentBet, liquidityPoints } = useAuctionContext();
  const promotionDescription = offer?.promotion?.promotionDescription;
  const isPerformanceVasPilot = !!offer?.promotion?.isPerformanceVasPilot;
  const isBet = !!(currentBet && !liquidityPoints);

  /**
   * @todo: удалить в задаче CD-260866
   */
  const isCpcAuctionEnabled = !!config.get<boolean>('auction.cpcEnabled');
  const isPerformanceVasFlag = !!config.get<boolean>('isPerformanceVASPilot.Enabled');

  if (
    !promotionDescription ||
    !shouldShowPromotionDescription({ offer, user, isCpcAuctionEnabled, isPerformanceVasEnabled: isPerformanceVasFlag })
  ) {
    return null;
  }

  const isCpcOffer = isCpcAuctionEnabled && getIsCpcAuction(offer);

  if (isCpcOffer) {
    return (
      <PromotionDescription
        promotionDescription={promotionDescription}
        isPerformanceVasPilot={false}
        item={[]}
        isBet={false}
        isCpcOffer={true}
      />
    );
  }

  // Здесь isPerformanceVasFlag гарантированно true (проверено в shouldShowPromotionDescription выше).
  return (
    <PromotionDescription
      promotionDescription={promotionDescription}
      isPerformanceVasPilot={isPerformanceVasPilot}
      item={vasList}
      isBet={isBet}
      isCpcOffer={isCpcOffer}
    />
  );
};
